import { createAction } from 'redux-actions';

import { FETCH_APPS, SET_IS_LOADING_TRUE } from './consts';

export const fetchApps = createAction(FETCH_APPS);
export const setIsLoadingTrue = createAction(SET_IS_LOADING_TRUE);
